export const IN_HOUSE_ANALYTICS_SUB_STRING = 'anyclip_analytics';

export const TYPE_VIDEO_PERFORMANCE_EXTERNAL = 'video_performance_external';
export const TYPE_VIDEO_PERFORMANCE_INTERNAL = 'video_performance_internal';
export const TYPE_LIVE_EVENTS = 'live_events';
export const TYPE_MONETIZATION = 'monetization';
export const TYPE_REVENUE_OVERVIEW = 'revenue_overview';
export const TYPE_REVENUE_BREAKDOWN = 'revenue_breakdown';
export const TYPE_DISPLAY_BIDDER = 'display_bidder';
export const TYPE_CUSTOM_REPORTS = 'custom_reports';

export default IN_HOUSE_ANALYTICS_SUB_STRING;
